import React from "react";
import NavBarComponent from "../NavBarComponent";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./projectstyles.css";
import styled from "styled-components";
import Footer from "../Footer/Footer";

const ProjectHeaderText = styled.p`
  text-align: center;
  color: yellow;
  font-size: 50px;
  font-family: "Bungee", cursive;
`;

const ProjectNameText = styled.h1``;

function Projects() {
  return (
    <>
      <NavBarComponent />
      <section id="projects" style={{ position: "relative" }}>
        <ProjectHeaderText>PROJECTS</ProjectHeaderText>
        <div class="project_description">
          <div class="project_list">
            <Row>
              <Col lg={6}>
                <div class="project">
                  <img src="images/projects/stock.png" alt="" />
                  <div class="project_detail">
                    <ProjectNameText>STOCK MARKET PREDICTION</ProjectNameText>
                    <h5>
                      In this project, the main objective was to show how good
                      is LSTM at datasets like Stock Market. It was a comparison
                      between LSTM and other regression algorithms. Model used :
                      Sequential. Layers used : LSTM, Dense. Dataset: Huge Stock
                      Market Dataset (Kaggle).
                    </h5>
                    <p>
                      Skills used : Pandas, Numpy, Matplotlib, Keras(Sequential,
                      Dense, LSTM), MinMaxScaler
                    </p>
                    <a href="https://github.com/rajdeepj1363/Stock-Market-Prediction-ML-">
                      GitHub Link
                    </a>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div class="project">
                  <img src="images/projects/covid.png" alt="" />
                  <div class="project_detail">
                    <ProjectNameText>COVID 19 TRACKER</ProjectNameText>
                    <h5>
                      This was an Android Application project mainly focused on
                      API Integration. The UI part of the app is quite simple.
                      The COVID-19 data is fetched from an API which gives two
                      statistics : World Count and Country-wise. Thus, app
                      includes both options i.e to check World Count or
                      Country-wise based on user input of country name.
                    </h5>
                    <p>Skills used : Android Studio, JAVA, XML, JSON</p>
                    <a href="https://github.com/rajdeepj1363/COVID-19-Tracker-Android-Application">
                      GitHub Link
                    </a>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div class="project">
                  <img src="images/projects/sps.png" alt="" />
                  <div class="project_detail">
                    <ProjectNameText>STONE PAPER SCISSOR</ProjectNameText>
                    <h5>
                      A Javascript based simple yet fun game to play between 2
                      people! Actual representation of real-world Stone Paper
                      Scissor. User can input number of rounds to Play and upon
                      finishing, result is displayed ! This was one of my
                      projects when I had just entered into Web Development
                      domain.
                    </h5>
                    <p>Skills used : HTML, CSS, Javascript</p>
                    <a href="https://rajdeepj1363.github.io/Stone_Paper_Scissor/">
                      Play it Now!
                    </a>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div class="project">
                  <img src="images/projects/rj.png" alt="" />
                  <div class="project_detail">
                    <ProjectNameText>TERMINAL RJ PATTERN</ProjectNameText>
                    <h5>
                      This was a side project just for fun which i created when
                      I was deep diving into Coding Questions based on Patterns!
                      The Sir who was teaching me on coding basics was bragging
                      about his student who created Avengers Logo pattern, so I
                      just answered him with RJ, which is just an initial of my
                      name :P !
                    </h5>
                    <p>Skills used : C++, Data Structures</p>
                    <a href="https://github.com/rajdeepj1363/RJ-Initials">
                      GitHub Link
                    </a>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div class="project">
                  <img src="images/projects/rfid.png" alt="" />
                  <div class="project_detail">
                    <ProjectNameText>RFID ATTENDANCE SYSTEM</ProjectNameText>
                    <h5>
                      This is an Electronics project, actually my BE
                      mini-project where along with 2 more partners, we built an
                      PIC16F877A based RFID Attendance system. This unit took
                      240V AC mains as Input and has inbuilt Transformer unit,
                      Regulator unit, Microcontroller Unit and LCD for
                      displaying status. One card is registered as
                      'Administrator' and other cards in PIC memory belong to
                      students. Upon tapping of admin card, attendance of all
                      students one by one is displayed on LCD.
                    </h5>
                    <p>
                      Skills used : Embedded Electronics, MPLAB, EasyEDA,
                      Proteus
                    </p>
                    <a href="https://github.com/rajdeepj1363/RFID-Attendance-System">
                      GitHub Link
                    </a>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div class="project">
                  <img src="images/projects/sunnycar.png" alt="" />
                  <div class="project_detail">
                    <ProjectNameText>
                      Sunny Car - Car Rental Website!
                    </ProjectNameText>
                    <h5>
                      This is a freelance project I did for a customer, its a
                      dynamic website containing all the required information
                      from a customer perspective and also includes Payment
                      Gateway. This enables users to book their ride at ease and
                      securely too. Currently their business is run from
                      Chiplun, Maharashtra and rents two varities of car :
                      Ertiga and Innova. Do check it out!{" "}
                    </h5>
                    <p>
                      Skills used : PHP, HTML, Bootstrap, MySQL, JS, Payment
                      Gateway Integration
                    </p>
                    <a href="https://www.sunnycar.in">Go to site</a>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Projects;
